import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ItemManagerComponent } from '../../utils/item-manager/item-manager.component';
import { DashboardService } from '../../../services/dashboard.service';
import { data } from 'jquery';
import { BloccoModel } from '../../../models/dashboard/blocco.model';
import { SliderModel } from '../../../models/dashboard/slider.model';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-manage-slider',
  templateUrl: './manage-slider.component.html',
  styleUrls: ['./manage-slider.component.css']
})
export class ManageSliderComponent implements OnInit {

  form: FormGroup;
  isLoading = true;
  sliderToken: string;
  slider: any;

  title = "Inserimento nuovo slider";

  constructor(
    fb: FormBuilder,
    private dialogRef: MdDialogRef<ManageSliderComponent>,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {
    this.createForm(fb);

    if (data) {
      this.title = "Modifica container homepage";
      const slider = this._sharedService.getSlider();
      this.sliderToken = (slider && slider.token) ? slider.token : null;
      this.setFormValues();
    }
  }

  ngOnInit() {
  }

  closeDialogRef(slider?: any) {
    this.dialogRef.close(slider);
  }

  createForm(fb: FormBuilder) {
    this.form = fb.group({
      cols: new FormControl(''),
      rowHeight: new FormControl('', Validators.compose([
        Validators.required,
        Validators.min(1)
      ])),
    });
  }

  getValueInJSON() {
    let formObj = this.form.getRawValue();
    return JSON.stringify(formObj);
  }

  invia() {
    const sliderToReturn = {
      id: this.slider.id,
      nomeSlider: this.slider.nomeSlider,
      ordineSlider: this.slider.ordineSlider,
      token: this.slider.token,
      colonneSlider: this.cols().value,
      righeSlider: this.rowHeight().value,
      pubblicato: this.slider.pubblicato,
      dataInizio: new Date()
    };

    if (this.slider) {
      this.closeDialogRef({ slider: sliderToReturn });
    }
  }

  setFormValues() {
    this.slider = this._sharedService.getSlider();
    const size = this.slider.colonneSlider;
    this.cols().setValidators(
      Validators.compose([
        Validators.required,
        Validators.min(1),
      ])
    );
    this.rowHeight().setValidators(
      Validators.compose([
        Validators.required,
        Validators.min(1),
      ])
    );

    // set dei valori nel form se sono in modifica

    if (this.sliderToken) {
      this.cols().setValue(this.slider.colonneSlider);
      this.rowHeight().setValue(this.slider.righeSlider);
    }
    this.isLoading = false;
  }

  rowHeight = () => this.form.get("rowHeight");
  cols = () => this.form.get("cols");

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/homepage-manager/manager-slider/manage-slider.component.ts